import React from "react";

const Solutions = () => {
  return (
    <section id="why-site" className="py-12 px-4 bg-gray-900">
      <div className="container mx-auto">
        <h2 className="text-3xl font-semibold text-center mb-8 text-yellow-400">
          Pourquoi Choisir Notre Solution ?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-center">
            <i className="fas fa-lock text-yellow-400 text-4xl mb-4"></i>
            <h3 className="text-xl font-semibold mb-2">Sécurité</h3>
            <p>
              Nous garantissons la sécurité de vos transactions et des données
              clients avec les dernières technologies de cryptage.
            </p>
          </div>
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-center">
            <i className="fas fa-mobile-alt text-yellow-400 text-4xl mb-4"></i>
            <h3 className="text-xl font-semibold mb-2">Responsive Design</h3>
            <p>
              Nos sites sont optimisés pour tous les appareils, offrant une
              expérience utilisateur fluide sur mobile, tablette et desktop.
            </p>
          </div>
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-center">
            <i className="fas fa-cogs text-yellow-400 text-4xl mb-4"></i>
            <h3 className="text-xl font-semibold mb-2">Personnalisation</h3>
            <p>
              Nous offrons des options de personnalisation étendues pour
              répondre exactement à vos besoins et objectifs commerciaux.
            </p>
          </div>
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-center">
            <i className="fas fa-headset text-yellow-400 text-4xl mb-4"></i>
            <h3 className="text-xl font-semibold mb-2">Support 24/7</h3>
            <p>
              Notre équipe de support est disponible 24 heures sur 24, 7 jours
              sur 7 pour vous aider en cas de besoin.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solutions;
